<route>
{
  "name": "chapterAdd",
  "meta": {
    "order": 3,
    "isVisible": false,
    "iconName": "mdi-pen"
  }
}
</route>
<template>
  <div>
    <page-title
      :title="$t('pages.chapter_add.title') +  ': ' + parentItem.name">
      <v-btn
        outlined
        @click="$router.go(-1)"
        color="secondary">
        {{$t('general.back')}}
      </v-btn>
    </page-title>
    <v-form
      v-model="formIsValid"
      class="form-horizontal"
    >
      <form-item
        v-model="formData.name"
        :class="{ 'col-3': formData.type === 'form-inline' }"
        type="textarea"
        :rows="2"
        icon="mdi-form-textbox"
        :label="$t('models.name')"
        :placeholder="$t('models.name')"
      ></form-item>
      <form-item
        v-model="formData.description"
        :class="{ 'col-3': formData.type === 'form-inline' }"
        type="textarea"
        :rows="6"
        icon="mdi-form-textbox"
        :label="$t('models.description')"
        :placeholder="$t('models.description')"
      ></form-item>
      <form-item
        v-model="formData.order"
        :class="{ 'col-3': formData.type === 'form-inline' }"
        type="number"
        icon="mdi-form-textbox"
        :label="$t('models.order')"
        :placeholder="$t('models.order')"
      ></form-item>
      <form-item
        v-model="formData.image"
        :class="{ 'col-3': formData.type === 'form-inline' }"
        type="textbox"
        icon="mdi-form-textbox"
        :label="$t('models.image')"
        :placeholder="$t('models.image')"
      ></form-item>
      <form-action>
        <v-btn
          :disabled="!formIsValid"
          color="success"
          depressed
          @click="onSubmitForm"
        >
          {{ $t('pages.forms.submitButtonText') }}
        </v-btn>
        <v-btn
          color="secondary"
          depressed
          outlined
          @click="$router.go(-1)"
        >
          {{ $t('pages.forms.cancelButtonText') }}
        </v-btn>
      </form-action>
    </v-form>
  </div>
</template>

<script>
export default {
  layout: APP_CONFIG.layout.mainPanelLayout,
  data: () => ({
    // NOTE: Keep this name same in all form pages and components
    formIsValid: true,
    // NOTE: Keep this name same in all form pages and components
    parentItem: {},
    formData: {
      name: '',
      description: '',
      image: '',
      order: 0
    }
  }),
  computed: {
  },
  mounted () {
    this.preLoadData()
  },
  methods: {
    preLoadData () {
      this.$store.dispatch('course/getById', {
        id: this.$route.params.id
      }).then((response) => {
        this.parentItem = response.data        
      })
    },
    add () {
      this.$store.dispatch('chapter/add', {
        course: this.$route.params.id,
        name: this.formData.name,
        description: this.formData.description,
        order: this.formData.order,
        image: this.formData.image,
      }).then((response) => {
        this.$router.go(-1)
      })
    },
    // NOTE: Keep this name same in all form pages and components
    onSubmitForm () {
      this.add()
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
